<template>
  <div>功能3</div>
</template>
<script>
export default {
  name: 'Header',
  components: {
  },
  data(){
    return {
    }
  },
  created: function () {
  },
  computed: {
  },
  watch: {
  },
  mounted: function(){
    console.log('功能3 mounted')
  },
  destroyed: function(){
    console.log('功能3 destroyed')
  },
  methods: {
  },
}
</script>